import React, { useEffect, useState } from "react";
import * as MatStyled from "@mui/material/styles";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import VisibilityIcon from "@mui/icons-material/Visibility";
// import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
// import { getLocale } from "react-i18nify";
import Stack from "@mui/material/Stack";

// import { makeStyles } from '@material-ui/core'

import { DataGrid } from "@mui/x-data-grid";
import { GridActionsCellItem } from "@mui/x-data-grid";
// import Pagination from "@mui/material/Pagination";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

import moment from "moment";
import { getSampleList } from "src/api/sample";
import { useAuth } from "src/hooks/useAuth";

const DivMuiName = styled.div`
  width: 100%;
  height: auto;
  padding: 32px;
  border-radius: 32px;
  background-color: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  // display: flex;
  justify-content: center;
  align-items: center;
`;

const DivMuiInside = styled.div`
  width: 100%;
  margin-bottom: 20px;
  display: flex;
`;

const WrapperText = styled.div`
  // margin-bottom: 32px;
  width: 45%;
  position: relative;
  display: flex;
  justify-content: center;
  .TextField-without-border-radius fieldset {
    border-radius: 16px;
  }
`;
const WrapperStatus = styled.div`
  width: 25%;
  position: relative;
  display: flex;
  justify-content: center;
  margin-top: 8px;
  .TextField-without-border-radius fieldset {
    border-radius: 16px;
  }
`;

const WrapperDataGrid = styled.div`
  height: 600px;
  width: 100%;
  .MuiDataGrid-root {
    border: 1px solid #ffffff;
  }
  .MuiDataGrid-columnHeaders {
    background-color: #f5f5f5;
  }
  .MuiDataGrid-root .MuiDataGrid-columnSeparator--sideRight {
    color: #f5f5f5;
  }
  .MuiDataGrid-root .MuiDataGrid-columnHeader:focus-within {
    // outline: solid #f5f5f5 1px;
    outline: none;
  }
  .MuiDataGrid-root .MuiDataGrid-cell:focus {
    outline: none;
    border-bottom: solid #f5f5f5 1px 0 1px 0;
  }
  .MuiDataGrid-root .MuiDataGrid-row.Mui-selected {
    background-color: #ffffff;
  }
`;

const ImageNoData = styled.image`
  width: 120px;
  height: 120px;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/no+data.svg");
  background-repeat: no-repeat;
  background-size: 100%;
`;
const ImageNotFound = styled.image`
  width: 120px;
  height: 120px;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/not+found.svg");
  background-repeat: no-repeat;
  background-size: 100%;
`;

const TextNoData = styled.pre`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
`;
const drawerWidth = 260;

const Main = MatStyled.styled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  position: "relative",
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
    position: "relative",
  }),
}));

const DrawerHeader = MatStyled.styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
  height: "75px",
}));

function SampleList({ open }) {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [sampleListData, setSampleListData] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [dataSearch, setDataSearch] = useState({
    keyword: null,
    page: 0,
    page_size: 10,
    status: "",
  });
  const [rowCount, setRowCount] = useState(0);

  // function CustomPagination() {
  //   const apiRef = useGridApiContext();
  //   const page = useGridSelector(apiRef, gridPageSelector);
  //   const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  //   return (
  //     <WrapperPagination>
  //       <Pagination
  //         color="primary"
  //         count={pageCount}
  //         page={page + 1}
  //         onChange={(event, value) => apiRef.current.setPage(value - 1)}
  //       />
  //     </WrapperPagination>
  //   );
  // }

  const columns = [
    {
      field: "full_name",
      headerName: "Sample Request",
      flex: 2,
      // width: 200,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              margin: "8px",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              outline: "none",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            <div style={{ margin: "8px", width: "100%" }}>
              <div
                className="MuiDataGrid-cellContent"
                style={{
                  marginBottom: "8px",
                  fontSize: "0.875rem",
                  fontWeight: 500,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Name : {params.row?.full_name ? params.row?.full_name : "-"}
              </div>
              <div
                className="MuiDataGrid-cellContent"
                style={{
                  marginBottom: "8px",
                  fontSize: "0.875rem",
                  fontWeight: 500,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Tel : {params.row?.phone_number}
              </div>
              <div
                className="MuiDataGrid-cellContent"
                style={{
                  marginBottom: "8px",
                  fontSize: "0.875rem",
                  fontWeight: 500,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Project : {params.row?.project ? params.row?.project : "-"}
              </div>
            </div>
          </Box>
        );
      },
    },
    {
      field: "createdAt",
      headerName: "Date Request",
      flex: 1,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <div className="rowitem">
            {params?.row?.createdAt
              ? moment(params?.row?.createdAt).format("DD-MM-YYYY")
              : "-"}
          </div>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <div className="rowitem">
            {+params?.row?.status === 0
              ? "Pending"
              : +params?.row?.status === 1
                ? "Approve"
                : "Reject"}
          </div>
        );
      },
    },
    {
      field: "actions",
      type: "actions",
      headerName: "",
      flex: 1,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<VisibilityIcon />}
          label="Detail"
          onClick={() => navigate(`/sample/detail/${params.row._id}`)}
          showInMenu
        />,
      ],
    },
  ];

  function NoRowsOverlay() {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <ImageNoData></ImageNoData>
        <TextNoData>No Data</TextNoData>
      </Stack>
    );
  }

  function NoResultsOverlay() {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <ImageNotFound></ImageNotFound>
        <TextNoData>Not Found</TextNoData>
      </Stack>
    );
  }

  const onSearchButton = () => {
    setDataSearch({ ...dataSearch, page: 0 });
    setIsLoading(true);
    (async () => {
      if (user.role_id === 1) {
        const { data } = await getSampleList({ ...dataSearch, page: 0 });
        setSampleListData(data.rows);
        setRowCount(data.count);
        setIsLoading(false);
      }
    })();
  };

  const handlePageChange = (newPage) => {
    // We have the cursor, we can allow the page transition.
    setDataSearch({ ...dataSearch, page: newPage });
  };
  useEffect(() => {
    setIsLoading(true);
    (async () => {
      if (user.role_id === 1) {
        const { data } = await getSampleList(dataSearch);
        setSampleListData(data.rows);
        setRowCount(data.count);
        setIsLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSearch.page, dataSearch.status]);

  return (
    <>
      <Main open={open}>
        <DrawerHeader />
        <DivMuiName>
          <DivMuiInside>
            <WrapperText>
              <TextField
                id="search-input"
                placeholder="ค้นหา"
                className="TextField-without-border-radius"
                sx={{
                  m: 1,
                  width: "100%",
                  borderRadius: "16px",
                }}
                InputProps={{
                  endAdornment: (
                    <IconButton
                      id="button-search-sample"
                      sx={{ padding: 0 }}
                      onClick={() => {
                        onSearchButton();
                      }}
                    >
                      <SearchIcon
                        sx={{ color: "#e04132", cursor: "pointer" }}
                      />
                    </IconButton>
                  ),
                }}
                onChange={(e) => {
                  setDataSearch({ ...dataSearch, keyword: e.target.value });
                }}
                onKeyUp={(e) => (e.code === "Enter" ? onSearchButton() : null)}
              />
            </WrapperText>
            <WrapperStatus>
              <FormControl fullWidth>
                <InputLabel>Status</InputLabel>
                <Select
                  className="TextField-without-border-radius"
                  id="search-input"
                  label="Age"
                  onChange={(e) => {
                    setDataSearch({ ...dataSearch, status: e.target.value });
                  }}
                >
                  <MenuItem value={""}>All</MenuItem>
                  <MenuItem value={1}>Approve</MenuItem>
                  <MenuItem value={0}>Pending</MenuItem>
                  <MenuItem value={2}>Reject</MenuItem>
                </Select>
              </FormControl>
            </WrapperStatus>

            {/* <WrapperButton>
              <Button
                className="Button-Add"
                startIcon={<AddIcon />}
                onClick={() => navigate("/product/upload")}
              >
                อัพโหลดสินค้า
              </Button>
            </WrapperButton> */}
          </DivMuiInside>

          <WrapperDataGrid>
            <DataGrid
              rows={sampleListData}
              getRowId={(row) => row._id}
              getRowHeight={() => "auto"}
              loading={isLoading}
              columns={columns}
              pageSize={10}
              rowCount={rowCount}
              paginationMode="server"
              page={dataSearch.page}
              onPageChange={(e) => handlePageChange(e)}
              rowsPerPageOptions={[10]}
              pagination
              disableSelectionOnClick
              // localeText={{
              //   footerRowSelected: CustomPagination,
              // }}
              components={{
                // Footer: CustomPagination,
                NoRowsOverlay,
                NoResultsOverlay,
              }}
              componentsProps={{
                basePopper: {},
              }}
              sx={{
                "& .MuiDataGrid-actionsCell": {
                  transform: "rotate(90deg)",
                },
              }}
            />
          </WrapperDataGrid>
        </DivMuiName>
      </Main>
    </>
  );
}

export default SampleList;
